import * as React from 'react';
import * as _ from 'lodash';
import { Row, Button } from 'react-bootstrap';

import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../../common/formatters';

export const defaultInputProps = {
    colInputXs: 6,
    colLabelXs: 6,
};

export const KendoFormDetailFormSection = ({ title, className = '', ...rest }) => {
    return (
        <div className={`kendo-form-detail-form-section ${className}`}>
            <KendoWrappers.KendoFormSection title={title}>
                {rest.children}
            </KendoWrappers.KendoFormSection>
        </div>
    );
};

export const InventoryDetailFormSection = ({ title, className = '', ...rest }) => {
    return (
        <div className={`regional-detail-form-section ${className}`}>
            <KendoWrappers.KendoFormSection title={title}>
                {rest.children}
            </KendoWrappers.KendoFormSection>
        </div>
    );
};

export const RegionalDetailFormSection = ({ title, className = '', ...rest }) => {
    return (
        <div className={`regional-detail-form-section ${className}`}>
            <KendoWrappers.KendoFormSection title={title}>
                {rest.children}
            </KendoWrappers.KendoFormSection>
        </div>
    );
};

export const InventoryDetailFormSectionSpacing = (rest) => {
    return (
        <div className="regional-detail-form-section-spacing inventory-detail-form-section-spacing" />
    );
};

export const ScenarioOptionRenderer = ({ focusedOption, focusedOptionIndex, focusOption, key, labelKey, option, optionIndex, options, selectValue, style, valueArray, valueKey, ...nameOptionsRest }) => {
    let classNames = ['name-option'];

    if (option.type === 'header') {
        classNames.push('name-header');

        return (
            <div
                className={classNames.join(' ')}
                key={key}
                style={style}
            >
                {option[labelKey]}
            </div>);
    } else {
        if (option === focusedOption) {
            classNames.push('name-focused-option');
        }

        if (valueArray.indexOf(option) >= 0) {
            classNames.push('name-option-selected');
        }

        const css = `scenario-name-option-wrapper ${classNames.join(' ')}`;

        return (
            <div
                className={css}
                key={key}
                onClick={() => selectValue(option)}
                onMouseEnter={() => focusOption(option)}
                style={style}
            >
                {option[labelKey]}
            </div>
        );
    }
};

export const NameOptionRenderer = ({ focusedOption, focusedOptionIndex, focusOption, key, labelKey, option, optionIndex, options, selectValue, style, valueArray, valueKey, ...nameOptionsRest }) => {
    let classNames = ['name-option'];

    if (option.type === 'header') {
        classNames.push('name-header');

        return (
            <div
                className={classNames.join(' ')}
                key={key}
                style={style}
            >
                {option[labelKey]}
            </div>);
    } else {
        if (option === focusedOption) {
            classNames.push('name-focused-option');
        }

        if (valueArray.indexOf(option) >= 0) {
            classNames.push('name-option-selected');
        }

        return (
            <div
                className={classNames.join(' ')}
                key={key}
                onClick={() => selectValue(option)}
                onMouseEnter={() => focusOption(option)}
                style={style}
            >
                {option[labelKey]}
            </div>
        );
    }
};

export const InventoryNote = ({ authorText, dateText, children, onClickDelete, onClickSave, deleteButtonVisible = true, saveButtonVisible = false, ...props }) => {
    return (
        <div className="inventory-note-container form-section">
            <div className="inventory-note-header">
                <Row>
                    <Col xs={9}>
                        <span className="inventory-note-author">{authorText}</span>
                        <span className="inventory-note-created">{dateText}</span>
                    </Col>
                    <Col xs={3} className="text-right">
                        {(saveButtonVisible) ? (
                            <Button bsStyle="success" bsSize="xs" onClick={(e) => { onClickSave(e); }}><i className="fa fa-save" /></Button>
                        ) : (<div />)}

                        {(deleteButtonVisible) ? (
                            <Button bsStyle="danger" bsSize="xs" onClick={onClickDelete}><i className="fa fa-trash-o" /></Button>
                        ) : (<div />)}
                    </Col>
                </Row>
            </div>
            <div className="inventory-note-text">
                {children}
            </div>
        </div>
    );
};

export const InventoryNoteRow = ({ children, ...props }) => {
    return (
        <Row>
            <Col xs={12}>
                {children}
            </Col>
        </Row>
    );
};

export const ReportNotes = ({ name, reportNotes, onClickDelete, onClickSave, deleteButtonVisible = true, saveButtonVisible = false, ...rest }) => {
    if (!_.size(reportNotes)) { return (<div />); }

    let result = _.map(reportNotes, (o, i) => {
        const objId = _.get(o, 'objectId');
        const created = _.get(o, 'created');

        return (
            <InventoryNoteRow key={`inventory-note-row-report-notes-${i}`}>
                <InventoryNote
                    authorText={`${Formatters.getStr(o, 'author.firstName')} ${Formatters.getStr(o, 'author.lastName')}`}
                    dateText={Formatters.formatDateLongDate(_.get(o, 'created', new Date()))}
                    onClickDelete={(e) => { onClickDelete({ target: { value: created, noteType: 'report', type: 'delete-button', name: name } }, o); }}
                    onClickSave={(e) => { onClickSave(e); }}
                    deleteButtonVisible={deleteButtonVisible}
                    saveButtonVisible={saveButtonVisible}
                >
                    <div>{Formatters.getStr(o, 'notes')}</div>
                </InventoryNote>
            </InventoryNoteRow>
        );
    });

    return (
        <div>
            {result}
        </div>
    );
};

export const OrderNotes = ({ name, orderNotes, onClickDelete, onClickSave, deleteButtonVisible = true, saveButtonVisible = false, ...rest }) => {
    if (!_.size(orderNotes)) { return (<div />); }

    let result = _.map(orderNotes, (o, i) => {
        const objId = _.get(o, 'objectId');
        return (
            <InventoryNoteRow key={`inventory-note-row-order-notes-${i}`}>
                <InventoryNote
                    authorText={`${Formatters.getStr(o, 'author.firstName')} ${Formatters.getStr(o, 'author.lastName')}`}
                    dateText={Formatters.formatDateLongDate(_.get(o, 'created', new Date()))}
                    onClickDelete={(e) => { onClickDelete({ target: { value: objId, noteType: 'order', type: 'delete-button', name: name } }, o); }}
                    onClickSave={(e) => { onClickSave(e); }}
                    deleteButtonVisible={deleteButtonVisible}
                    saveButtonVisible={saveButtonVisible}
                >
                    <div>{Formatters.getStr(o, 'notes')}</div>
                </InventoryNote>
            </InventoryNoteRow>
        );
    });

    return (
        <div>
            {result}
        </div>
    );
};

export const OrderFollowUpNotes = ({ name, orderFollowUpNotes, onClickDelete, onClickSave, deleteButtonVisible = true, saveButtonVisible = false, ...rest }) => {
    if (!_.size(orderFollowUpNotes)) { return (<div />); }

    let result = _.map(orderFollowUpNotes, (o, i) => {
        const objId = _.get(o, 'objectId');
        return (
            <InventoryNoteRow key={`inventory-note-row-order-follow-up-notes-${i}`}>
                <InventoryNote
                    authorText={`${Formatters.getStr(o, 'author.firstName')} ${Formatters.getStr(o, 'author.lastName')}`}
                    dateText={Formatters.formatDateLongDate(_.get(o, 'created', new Date()))}
                    onClickDelete={(e) => { onClickDelete({ target: { value: objId, noteType: 'follow-up', type: 'delete-button', name: name } }, o); }}
                    onClickSave={(e) => { onClickSave(e); }}
                    deleteButtonVisible={deleteButtonVisible}
                    saveButtonVisible={saveButtonVisible}
                >
                    <div>{Formatters.getStr(o, 'notes')}</div>
                </InventoryNote>
            </InventoryNoteRow>
        );
    });

    return (
        <div>
            {result}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/regional-component-lists/detail-form/common.tsx